module.exports = __webpack_public_path__ + "img/solutions2.4c51c334.png";